<template>
  <v-dialog width="400px" :value="value" @input="toggleModal()">
    <v-card class="error pb-2" style="border-radius: 10px">
      <v-card-text>
        <v-row>
          <v-col class="text-center py-4" cols="12" >
            <v-icon color="white" size="50">warning</v-icon>
          </v-col>
          <v-col cols="12" class="white--text text-center">
            <h4>
              {{ title || $t('general.doYouWantToDeleteThisItem') }}
            </h4>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn color="white"
               outlined
               @click="toggleModal()">
          {{ $t('general.cancel') }}
        </v-btn>
        <v-btn color="white"
               class="error--text"
               :loading="deleting"
               @click="submit()">
          {{ $t('general.delete') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      deleting: false
    }
  },
  methods: {
    async submit () {
      try {
        this.deleting = true
        this.$emit('onDeleteItem')
        this.deleting = false
        this.toggleModal()
      } catch (e) {
        this.deleting = false
      }
    },
    toggleModal () {
      this.$emit('input', false)
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>
